import type { Node, NodeProps } from '@xyflow/react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { nodeLabel } from '../graphModel';
import { chevronProps, type FlowNodeData } from '../useGraphLayout';
import { KIND_PALETTE } from '../kindPalette';
import { FootLine } from './FootLine';
import { NodeShell } from './NodeShell';

export function PartNode({ data }: NodeProps<Node<FlowNodeData>>) {
  if (data.node.kind !== 'part') return null;
  const { partNumber, serialNumber, description } = data.node;
  return (
    <NodeShell
      icon={WrenchScrewdriverIcon}
      iconClassName="text-emerald-600 dark:text-emerald-400"
      compactClassName={KIND_PALETTE.part.compact}
      label={nodeLabel(data.node)}
      selected={data.selected}
      focused={data.focused}
      {...chevronProps(data)}
      className="w-50"
    >
      <div className="truncate text-sm font-medium">P/N {partNumber}</div>
      <div className="truncate text-xs">S/N {serialNumber}</div>
      <FootLine text={description} mentions={data.mentions} />
    </NodeShell>
  );
}
